import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-edit-lead-medium-dialog',
  templateUrl: './edit-lead-medium-dialog.component.html',
  styleUrls: ['./lead-medium.component.css']
})
export class EditLeadMediumDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<EditLeadMediumDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    this.dialogRef.close({ action: 'save', model: this.data.model });
  }

}
